import { useState, useEffect } from 'react';
import { scriptsService } from '../services/scriptsService';

export function useScript(tipo) {
  const [script, setScript] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tipo) { setScript(null); return; }
    let cancelled = false;
    setLoading(true);
    setError(null);
    scriptsService.getScript(tipo).then(s => {
      if (!cancelled) { setScript(s); setLoading(false); }
    }).catch(e => {
      if (!cancelled) { setError(e.message); setLoading(false); }
    });
    return () => { cancelled = true; };
  }, [tipo]);

  return { script, loading, error };
}
